import React from 'react';
import { getRestaurantConfigSync } from '../../config/restaurantConfig';
import { X, Gift, Package, ShoppingCart } from 'lucide-react';
import './index.css';
import { settingsService } from '../../config/settingsService';

const ComboDetailsModal = ({ isOpen, onClose, combo, onAddToCart, isUserLoggedIn, onShowAuthModal }) => {
  if (!isOpen || !combo) return null;

  const comboPrice = parseFloat(combo.comboData?.combo_price || combo.price || 0);

  // ✅ Support both API formats: combo_items_details (Offers) and combo_components (Products)
  const components = combo.comboComponents || combo.combo_components || combo.comboData?.combo_items_details || [];

  const handleAddToCart = () => {
    onAddToCart(combo);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content combo-modal" onClick={(e) => e.stopPropagation()}>
        
        {/* Compact POS Header */}
        <div className="combo-modal-header-pos">
          <div className="combo-header-left">
            <div className="combo-header-icon">
              <Package size={20} />
            </div>
            <h2 className="combo-modal-title">{combo.name}</h2>
          </div>
          <button onClick={onClose} className="modal-close-btn-pos">
            <X size={20} />
          </button>
        </div>

        <div className="combo-modal-body">
          <div className="bundle-label">Bundle Includes</div>

          <div className="combo-items-list">
            {components.map((item, index) => (
              <div key={index} className="combo-item-row">
                <div className="qty-box">
                  x{parseFloat(item.quantity || 1)}
                </div>
                <div className="item-info">
                  <span className="item-name">{item.component_item_name || item.item_name || item.name}</span>
                  {(item.component_variation_name || item.variation_name) && (
                    <span className="item-variation">
                      {item.component_variation_name || item.variation_name}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Compact POS Footer with Cancel Button */}
        <div className="combo-modal-footer-pos">
          <button 
            className="combo-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            onClick={handleAddToCart}
            className="combo-add-btn-pos"
          >
            <ShoppingCart size={18} strokeWidth={2.5} />
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComboDetailsModal;